import React from 'react';
import {RolesTable} from '../components/RolesTable';

export function Roles() {
  return <RolesTable />;
}
